import { createNode } from '@glueapp/graph-types';

const placeholderRegex: RegExp = /\${(.+?)}/g;

function getPlaceholdersFromText(text: string): string[] {
    return [...new Set([...text.matchAll(placeholderRegex)].map(m => m[1]))];
}

export const TextTemplate = createNode({
    id: 'Text Template',
    name: 'Text Template',
    description:
        'Enter your template using the pattern of ${PLACEHOLDER} to add pieces of text you want to replace with inputs from the graph. Example: Hi ${NAME} you are ${AGE} years old.',
    aiDescription:
        'Builds a string from a template with dynamic placeholders.\n' +
        'Step 1: Set the template text via state:\n' +
        "  glue set-state <id> textValue 'Hello ${NAME}, you are ${AGE} years old.'\n" +
        'Step 2: Run `glue shape <id>` to see the generated input ports (one per unique ${PLACEHOLDER}).\n' +
        'Step 3: Connect string values to each placeholder port (e.g., connect to the "NAME" and "AGE" ports).\n' +
        'Output: single "Output" port with the fully interpolated string.\n' +
        'Note: uses interfaceComponentId text-template-editor; the computeShape logic parses ${...} patterns from state.textValue to create input ports dynamically.',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {},
    outPorts: {
        Output: { kind: 'string' },
    },
    interfaceComponentId: 'text-template-editor',
    computeShape: input => {
        const template = (input.state?.textValue as string) || '';
        const placeholders = getPlaceholdersFromText(template);
        return {
            inPorts: placeholders.map(placeholder => ({
                name: placeholder,
                type: { kind: 'string' as const },
            })),
            outPorts: input.nodeOutPorts,
        };
    },
    execute: function (input) {
        const template = input.state.textValue as string;

        const placeholders = getPlaceholdersFromText(template);

        let outputText = template;
        for (let placeholder of placeholders) {
            // @ts-expect-error
            const inputValue = input.inPorts[placeholder];
            if (inputValue === undefined) {
                throw new Error(`Input with name: ${placeholder} could not be found.`);
            }
            const placeholderRegex = new RegExp('\\$\\{' + placeholder + '\\}', 'g');
            outputText = outputText.replace(placeholderRegex, inputValue);
        }

        return { output: { Output: outputText } };
    },
});
